<router-outlet></router-outlet>
<router-outlet name="modal"></router-outlet>

<app-global-loader></app-global-loader>
<wb-ui-toast></wb-ui-toast>

